import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBreadcrumbs,{attrs:{"items":_vm.crumbs},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{class:[props.item.disabled && 'disabled'],attrs:{"to":props.item.to}},[_vm._v(_vm._s(props.item.text.toUpperCase()))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }